import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NotificationMessage } from '../model/interfaces/notification-message';

@Injectable()
export class NotificationService
{
    private notification: NotificationMessage;
    private dataSource: BehaviorSubject<NotificationMessage>;
    private notification$: Observable<NotificationMessage>;

    constructor()
    {
        this.dataSource = new BehaviorSubject(this.notification);
        this.notification$ = this.dataSource.asObservable();
    }

    public notify(notification: NotificationMessage): void
    {
        this.dataSource.next(notification);
    }

    public getNotificationMessageObservable(): Observable<NotificationMessage>
    {
        return this.notification$;
    }
}


